import {
  BasketballEventDetailId,
  CommonEventDetailId,
} from '@collector/sportsapi-client-legacy'

import { EventInfoControls } from '../../configuration'

export const eventInfoControls: EventInfoControls = [
  {
    grid: {
      cols: '3',
      controls: [
        {
          eventDetailId: BasketballEventDetailId.PeriodLength,
          postfix: 'min',
          maxlength: 3,
        },
        {
          eventDetailId: BasketballEventDetailId.NumberOfPeriods,
          label: 'Nr of periods',
          maxlength: 1,
          wide: true,
        },
        {
          eventDetailId: CommonEventDetailId.HasLineups,
        },
        {
          eventDetailId: BasketballEventDetailId.ExtraPeriodLength,
          label: 'Extra period',
          maxlength: 3,
          postfix: 'min',
        },
        {
          eventDetailId: BasketballEventDetailId.NumberOfExtraPeriods,
          label: 'Nr of extra periods',
          maxlength: 3,
          wide: true,
        },
        {
          eventDetailId: BasketballEventDetailId.JumpBallWinner,
          wide: true,
        },
        {
          eventDetailId: BasketballEventDetailId.TimerDirection,
        },

        {
          eventDetailId: BasketballEventDetailId.PossessionTimeLimit,
          postfix: 's',
          maxlength: 3,
          wide: true,
        },
        'TeamColorsSwitch',
        'empty',
        'empty',
        'AssignPlayerOnPitchSwitch',
      ],
    },
  },
]
